<template>
  <div>
    <div class="info-box">
      <div class="title-box">
        <p>学校信息维护</p>
      </div>
      <div class="info-content" v-loading="loading" :element-loading-text="loadingText">
        <div class="set-box">
          <el-col :span="24">
            <el-row>
              <el-col :span="24">
                <el-form ref="volunteerForm" :model="data" :rules="rules" label-width="140px">
                  <el-form-item label="学校名称" prop="name">
                    <el-input v-model="data.name" style="width:600px;" placeholder="请输入学校名称" disabled></el-input>
                  </el-form-item>
                  <el-form-item label="所在地区">
                    <el-input :value="data.province_text+data.city_text+data.country_text" style="width:600px;" disabled></el-input>
                  </el-form-item>
                  <el-form-item label="学校详细地址" prop="address">
                    <el-input v-model="data.address" style="width:600px;" placeholder="请输入学校详细地址"></el-input>
                  </el-form-item>

                  <el-form-item label="校长姓名" prop="president_name">
                    <el-input
                      v-model="data.president_name"
                      style="width:600px;"
                      placeholder="请输入校长姓名"
                    ></el-input>
                  </el-form-item>

                  <el-form-item label="校长联系电话" prop="president_mobile">
                    <el-input
                      v-model="data.president_mobile"
                      style="width:600px;"
                      placeholder="请输入校长联系电话"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="学校联系邮箱" prop="president_email">
                    <el-input
                      v-model="data.president_email"
                      style="width:600px;"
                      placeholder="请输入学校联系邮箱"
                    ></el-input>
                  </el-form-item>

                  <el-form-item>
                    <el-button type="primary" @click="submitForm">{{buttonText}}</el-button>
                    <el-button @click="$router.go(-1)">取消</el-button>
                  </el-form-item>
                </el-form>
              </el-col>
            </el-row>
          </el-col>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations } from "vuex";
import { isvalidEmail, isvalidPhone } from "@/libs/validate";
export default {
  data() {
    var validEmail = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入学校联系邮箱"));
      } else if (!isvalidEmail(value)) {
        callback(new Error("请输入正确的电子邮箱"));
      } else {
        callback();
      }
    };
    var validPhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入校长联系电话"));
      } else if (!isvalidPhone(value)) {
        callback(new Error("请输入正确的联系电话"));
      } else {
        callback();
      }
    };
    return {
      title: "注册",
      isEdit: false,
      identityList: [],
      sexList: [],
      typeList: [],
      nationList: [],
      sizeList: [],
      educationList: [],
      skillList: [],
      buttonText: "保存修改",
      info: {}, //用户信息
      rules: {
        name: [{ required: true, message: "请输入学校名称", trigger: "blur" }],
        president_email: [
          { required: true, validator: validEmail, trigger: "blur" }
        ],
        president_mobile: [
          { required: true, validator: validPhone, trigger: "blur" }
        ],
        address: [
          { required: true, message: "请输入学校详细地址", trigger: "blur" }
        ],
        president_name: [
          { required: true, message: "请输入校长姓名", trigger: "blur" }
        ]
      },
      loading: true,
      loadingText: "拼命加载中",
      areaShow: false,

      dialogVisible: false,
      data: {},
      search: {},

      navStatus: 1
    };
  },
  methods: {
    /**
     * 引入函数
     */
    ...mapActions([
      "getDictList",
      "getNations",
      "getSkill",
      "getRegions",
      "getUserStatus"
    ]),
    submitForm() {
      let self = this;
      this.$refs.volunteerForm.validate(valid => {
        if (valid) {
          //self.loading = true;
          self.loadingText = "正在执行中";
          self.$db.put(self.$url.school.url, self.data).then(resp => {
            if (resp && resp.data) {
              self.loading = false;
              self.$alert("信息编辑成功", "提示", {
                confirmButtonText: "确定",
                type: "success",
                callback: action => {
                  window.location.reload();
                }
              });
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    toogleExpand(row) {
      let $table = this.$refs.table;
      $table.toggleRowExpansion(row, false);
    },
    handleEdit(data) {
      console.log(data);
      this.dialogVisible = true;
    },
    getNav(id) {
      this.navStatus = id;
      this.$router.push({ name: "centerHomeIndex" });
    },
    getDate(date, format = "M") {
      switch (format) {
        case "M": {
          return date.substring(5, 7);
          break;
        }
        case "D": {
          return date.substring(8, 10);
          break;
        }
      }
    },
    getClass(index) {
      let j = parseInt(index / 3);
      if (j % 2 == 0) {
        // 再通过取模来设置每隔3行显示不同的两种颜色
        return "liBg2";
      } else {
        //return "liBg3"
        return "liBg2";
      }
    }
  },
  mounted() {
    this.$db.get(this.$url.school.url).then(resp => {
      this.data = resp.data;
      console.log(this.data,"data");
      this.loading = false;
    });
  }
};
</script>


<style lang="scss" scoped>
.profile-position {
  padding: 5px 0;
  color: #515a6e;
}
.info-box {
  margin-top: 4.0740740740740744vh;
  .title-box {
    display: flex;
    justify-content: space-between;
    width: 100%;
    > p {
      color: #414c60;
      font-size: 2.2222222222222223vh;
      line-height: 2.2222222222222223vh;
    }
    > h5 {
      font-weight: normal;
      color: #8d95a4;
      font-size: 2.2222222222222223vh;
      line-height: 2.2222222222222223vh;
    }
  }
  .info-content {
    display: flex;
    justify-content: space-between;
    margin-top: 1.6666666666666666vh;
    padding-bottom: 4.351851851851852vh;
    .set-box {
      //height: 19.518518518518517vh;
      //width: 30.833333333333335vw;
      width: 100%;
      padding: 15px;
      box-shadow: 0px 0px 20px 0px rgba(0, 1, 3, 0.1);
      border-radius: 0.5555555555555556vh;
      display: flex;
      justify-content: space-between;
      .set-info {
        padding-left: 9.895833333333333vw;
        height: 100%;
        position: relative;
        overflow: hidden;
        > img {
          width: 12.407407407407407vh;
          height: 12.407407407407407vh;
          border-radius: 50%;
          overflow: hidden;
          position: absolute;
          left: 1.8229166666666668vw;
          top: 50%;
          transform: translateY(-50%);
        }
        > h5 {
          font-weight: normal;
          color: #414c60;
          font-size: 2.2222222222222223vh;
          line-height: 2.2222222222222223vh;
          margin-top: 5.185185185185185vh;
          margin-bottom: 1.5370370370370372vh;
        }
        > p {
          color: #8d95a4;
          font-size: 1.6666666666666666vh;
          line-height: 1.6666666666666666vh;
          margin-bottom: 1.2962962962962963vh;
        }
      }
      .set-btn {
        margin-right: 3.958333333333333vw;
        overflow: hidden;
        > h5 {
          font-weight: normal;
          font-size: 3.333333333333333vh;
          color: #1caee0;
          margin-top: 6.111111111111111vh;
        }
        > p {
          color: #1caee0;
          font-size: 1.4814814814814815vh;
          margin-top: 0.8407407407407408;
          text-align: center;
        }
      }
    }
  }
}
</style>
<style lang="scss" scoped>
#app-activity {
  width: 100%;
  // margin-bottom: 45px;
  background-color: #f5f5f5;
}
.activity-box {
  margin: 0 auto;
  padding: 15px 0;
  .activity-top {
    position: relative;
    padding-left: 18px;
    display: flex;
    justify-content: space-between;
    margin-bottom: 40px;
    > span {
      width: 2px;
      // height: 55px;
      height: 100%;
      background-image: linear-gradient(
          0deg,
          #8ec31f 0%,
          #4eb875 10%,
          #2dbadc 20%,
          #258bcc 31%,
          #273d96 43%,
          #944496 50%,
          #bb4695 53%,
          #dc0536 65%,
          #e83a16 76%,
          #fcd475 89%,
          #d7de00 100%
        ),
        linear-gradient(#c12411, #c12411);
      position: absolute;
      left: 0;
      top: 0;
    }
    .top-l {
      > p {
        font-size: 24px;
        font-weight: normal;
        color: #999999;
      }
      > h3 {
        font-size: 24px;
        font-weight: 500;
        color: #333;
      }
    }
    .top-r {
      padding-right: 25px;
      position: relative;
      width: 308px;
      > ul {
        display: flex;
        justify-content: space-between;
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
        > li {
          list-style: none;
          margin-right: 30px;
          font-size: 15px;
          font-weight: normal;
          color: #333333;
          padding-bottom: 3px;
          cursor: pointer;
          // &:last-child { // margin-right: 0; // }
          &.active {
            border-bottom: 2px solid #e83a16;
            color: #e83a16;
          }
        }
      }
      > i {
        width: 25px;
        height: 25px;
        position: absolute;
        top: 50%;
        right: 0;
        transform: translateY(-50%);
        background: url(../../../assets/images/more.png) no-repeat;
        background-size: 100% 100%;
        &:hover {
          background: url(../../../assets/images/more1.png) no-repeat;
          background-size: 100% 100%;
        }
      }
    }
  }
  .activity-bottom {
    width: 100%;
    > ul {
      flex-wrap: wrap;
      display: flex;
      //justify-content: space-between;
      .liBg1 {
        background-color: #89ba29;
      }
      .liBg2 {
        background-color: #89ba29;
      }
      .liBg3 {
        background-color: #f8b92b;
      }
      > li {
        list-style: none;
        width: 29%;
        margin: 0px 25px 25px 25px;
        background-color: #89ba29;
        box-shadow: 0px 6px 19px 0px rgba(11, 2, 5, 0.09);
        position: relative;
        cursor: pointer;
        &:hover {
          .act-bottom {
            > p {
              color: #eee;
            }
            > h3 {
              color: #eee;
            }
          }
        }

        .act-top {
          width: 100%;
          //height: 210px;
          > img {
            width: 100%;
            height: 100%;
          }
        }
        .act-center {
          position: absolute;
          width: 75px;
          height: 47px;
          background-color: #ffffff;
          left: 24px;
          top: 175px;
          padding: 14px 0;
          > p {
            font-size: 14px;
            font-weight: normal;
            color: #89ba29;
            text-align: center;
          }
          > h5 {
            font-size: 24px;
            font-weight: normal;
            color: #89ba29;
            text-align: center;
          }
        }
        .act-bottom {
          padding: 63px 34px 28px 24px;
          > p {
            font-size: 16px;
            font-weight: normal;
            color: #ffffff;
            margin-bottom: 18px;
          }
          > h3 {
            font-size: 14px;
            font-weight: normal;
            color: #ffffff;
          }
        }
      }
    }
  }
}
.same_city_Li_dizhiQu {
  width: 100%;
  height: 22px;
  margin-top: 4px;
}
.same_city_Li_time {
  display: inline-block;
  line-height: 20px;
  font-size: 13px;
  color: #fff;
  float: left;
  margin-right: 15px;
}
.same_city_Li_address {
  display: inline-block;
  line-height: 20px;
  font-size: 13px;
  color: #fff;
  float: left;
  white-space: nowrap;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  overflow: hidden;
  text-align: left;
}

.status {
  position: absolute;
  width: 130px;
  right: 0px;
  top: 0px;
  color: #fff;
  font-size: 14px;
  line-height: 36px;
  font-weight: 500;
  text-align: center;
}
.status.ing {
  background-color: rgba(255, 111, 2, 0.8);
}
.status.end {
  background-color: #999;
}
.status.coming {
  background-color: #f8b92b;
}
</style>

<style>
.editor .el-form-item__content {
  line-height: 20px;
}
</style>



// WEBPACK FOOTER //
// src/view/Center/user/schoolInfo.vue